import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { msalInstance } from './services/AuthConfig';
import { EventType } from '@azure/msal-browser';

async function startApp() {
    try {
        await msalInstance.initialize();

        const result = await msalInstance.handleRedirectPromise();

        if (result) {
            msalInstance.setActiveAccount(result.account);
        } else {
            const accounts = msalInstance.getAllAccounts();
            if (accounts.length > 0) {
                msalInstance.setActiveAccount(accounts[0]);
            }
        }

        msalInstance.addEventCallback((event) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
                msalInstance.setActiveAccount(event.payload.account);
            }
        });

        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(
            <React.StrictMode>
                <App instance={msalInstance} />
            </React.StrictMode>
        );
    } catch (error) {
        console.error("Erro na inicialização do App:", error);
    }
}

startApp();